import { BooleanFormType } from "Store/interfaces/FormTypes";

export interface AdvicePriceFormValues {
  isAdvisor: boolean;
  disabilityCheckedToPurchase: boolean;
  disabilityInsuredSumValue: number;
  disabilityPaymentAfter3Months: BooleanFormType | undefined;
  disabilityOneTimePayment: boolean;
  disabilityOneTimePaymentValue: number;
  disabilityOneTimePaymentAdvisorChoice:
    | OneTimePaymentAdvisorChoice
    | undefined;
  disabilityOneTimePaymentAdvisorValue: string | undefined;
  deathCheckedToPurchase: boolean;
  deathInsuredSumValue: number;
  criticalIllnessCheckedToPurchase: boolean;
  criticalIllnessInsuredSumValue: number;
  childProductCheckedToPurchase: boolean;
  adviceComment: string | undefined;
  adviceDiffConsent: boolean | undefined;
}

export enum OneTimePaymentAdvisorChoice {
  ADVICED_ONE_TIME_PAYMENT = "ADVICED_ONE_TIME_PAYMENT",
  CUSTOM_ONE_TIME_PAYMENT = "CUSTOM_ONE_TIME_PAYMENT",
  NO_ONE_TIME_PAYMENT = "NO_ONE_TIME_PAYMENT",
}
